export const FETCH_PAST_ORDERS = "pastOrders/FETCH_PAST_ORDERS";
export const FETCH_PAST_ORDERS_SUCCESS = "pastOrders/FETCH_PAST_ORDERS_SUCCESS";
export const FETCH_PAST_ORDERS_FAIL = "pastOrders/FETCH_PAST_ORDERS_FAIL";
